export default __webpack_public_path__ + "static/media/Distriboissons.39da840e.svg";